import React, { useState } from 'react'
import { Button, Spinner, Alert } from 'react-bootstrap'
import { applyDiscountOffer } from '../../../services/manage'
import { getMergedPlan } from 'constants/plans'
import moment from 'moment'

const DiscountOffer = ({ onHide, onContinueCancellation, currentPlanId, nextBillingDate, currency }) => {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(null)

  const planPrices = getMergedPlan(currentPlanId, currency)

  const currentPlanPrice = planPrices?.prices['monthly']?.value
  const currentPlanCurrency = planPrices?.prices['monthly']?.symbol
  const currentPlanLabel = planPrices?.label
  const discountedPrice = (currentPlanPrice / 2).toFixed(2)

  const formattedNextBillingDate = isNaN(nextBillingDate)
    ? nextBillingDate
    : moment.unix(nextBillingDate).format('DD MMM YY')

  const handleRedeemOffer = async () => {
    setLoading(true)
    try {
      await applyDiscountOffer()
      setSuccess(true)
      setError(null)
    } catch (err) {
      console.error('Error applying discount:', err)
      setError('There was an error applying your discount. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return (
      <div className="text-center ">
        <h1 className="modalTitle">Offer Redeemed</h1>
        <p className="mb-4 font-16">
          Your next subscription payment will be charged on {formattedNextBillingDate} and will include your 50%
          discount. If you decide to stay, your following payments will go back to the usual price.
        </p>
        <Button variant="purple" onClick={onHide}>
          Close
        </Button>
      </div>
    )
  }

  return (
    <div className="text-center">
      <h1 className="modalTitle">Get an extra month for 50% off</h1>
      <p className="mb-4 font-18 p-3">
        {`Enjoy another full month of your ${currentPlanLabel} plan for half the price. That's just ${currentPlanCurrency}${discountedPrice}`}
      </p>

      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}

      <div className="d-flex justify-content-end">
        <Button variant="purple" className="mx-1" onClick={handleRedeemOffer} disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : 'Redeem offer'}
        </Button>
        <Button variant="outline-primary" className="mx-1" onClick={onContinueCancellation} disabled={loading}>
          Continue with cancellation
        </Button>
      </div>
    </div>
  )
}

export default DiscountOffer
